import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { VIEW_SCHEDULED_KEY } from '../../utils/translation-constants'
import '../../index.css'
import { carouselCurrentItemSelector } from '../../selectors'
import Loading from 'custom/assets/loaders/Loading'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import NumberFormat from 'react-number-format'
import 'custom/styles/color_variable.css'
import { NeoOTP, NeoSuccess } from '../../components/FormComponents'
import moment from 'moment'
import PaymentsService from '../../services/payments.service'
import Pagination from 'react-js-pagination'

export default function PaymentsViewScheduled() {
  const history = useHistory()
  const [expanded, setExpanded] = useState(null)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  // const [loadingSideBar, setLoadingSideBar] = useState(false)
  const [stage, setStage] = useState(0)
  const currentAccountDetails = useSelector(carouselCurrentItemSelector)
  const [scheduledList, setScheduledList] = useState([])
  const [selectedScheduledDetails, setSelectedScheduledDetails] = useState({})
  const [otp, setOtp] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const pageLimit = 10
  const [totalRecords, setTotalRecords] = useState(10)

  const viewScheduledPaymentsList = useCallback(async (page) => {
    try {
      setLoading(true)
      setStage(0)
      const reqParams = {
        page: page,
        size: pageLimit,
      }
      const response = await PaymentsService.viewScheduledPayments(reqParams)
      if (response.status === 200) {
        setScheduledList(response.data['items'])
        setTotalRecords(response.data['total'])
      }
      setStage(1)
      setLoading(false)
    } catch (err) {
      setLoading(false)
      setStage(1)
      setScheduledList([])
    }
  }, [])

  useEffect(() => {
    viewScheduledPaymentsList(0)
  }, [])

  const verifyCancelScheduledPayment = useCallback(
    async (selected) => {
      try {
        setLoading(true)
        setSelectedScheduledDetails(selected)
        const reqParams = {
          id: selected?.id,
        }
        const response = await PaymentsService.verifyCancelScheduledPayments(reqParams)
        if (response.status === 200) {
          if (response?.data?.otpEnable) setStage(2)
          else {
            const response1 = await PaymentsService.confirmCancelScheduledPayments({
              otp: '',
              ...reqParams,
            })
            if (response1.status === 200) {
              setMessage(response1.data.message)
              setLoading(false)
              setStage(3)
            }
          }
        }
        setLoading(false)
      } catch (err) {
        setLoading(false)
      }
    },
    [selectedScheduledDetails],
  )

  const confirmCancelScheduledPayment = useCallback(async () => {
    try {
      setLoading(true)
      let reqParams = {
        otp: otp,
        id: selectedScheduledDetails.id,
      }
      const response = await PaymentsService.confirmCancelScheduledPayments(reqParams)
      if (response.status === 200) {
        setMessage(response.data.message)
        setLoading(false)
        setStage(3)
      }
    } catch (err) {
      setLoading(false)
      setOtp('')
    }
  }, [otp, selectedScheduledDetails, message])

  const paginationChange = useCallback(async (page) => {
    setCurrentPage(page)
    await viewScheduledPaymentsList(page - 1)
  }, [])

  const onSuccess = useCallback(async () => {
    setExpanded(null)
    setOtp('')
    await viewScheduledPaymentsList(0)
  }, [])

  const getTransferType = useCallback((transferType) => {
    switch (transferType) {
      case 'OAT':
        return t(VIEW_SCHEDULED_KEY.OAT)
      case 'RTGS':
        return t(VIEW_SCHEDULED_KEY.RTGS)
      case 'IAT':
        return t(VIEW_SCHEDULED_KEY.IAT)
      case 'SWIFT':
        return t(VIEW_SCHEDULED_KEY.SWIFT)
      case 'DDACC':
        return t(VIEW_SCHEDULED_KEY.DDACC)
    }
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderReceiptsViewForm()
      case 2:
        return (
          <div className='new-design-form-style'>
            {/* <div className='heading-style1'>
                {t(MENU_KEYS.VIEW_SCHEDULED)}
              </div> */}
            <NeoOTP
              otp={otp}
              setOTP={setOtp}
              onSubmit={confirmCancelScheduledPayment}
              loading={loading}
            />
          </div>
        )
      case 3:
        return (
          <div className='new-design-form-style'>
            {/* <div className='heading-style1'>
                {' '}
                {t(MENU_KEYS.VIEW_SCHEDULED)}
              </div> */}
            <NeoSuccess message={message} onClick={onSuccess} />
          </div>
        )
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderReceiptsViewForm() {
    return (
      <div style={{ justifyContent: ' space-between', alignItems: 'center' }}>
        {scheduledList.map((item, index) => (
          <div
            key={index}
            className='loan-card '
            onClick={() => (expanded === index ? setExpanded(null) : setExpanded(index))}>
            <div className='loan-header'>
              <div>
                <span>
                  {t(VIEW_SCHEDULED_KEY.SERVICENO)} :{' '}
                  {item?.serviceNumber !== null ? item?.serviceNumber : '-'}
                </span>
                <div style={{ display: 'flex' }}>
                  <span>{t(VIEW_SCHEDULED_KEY.SCHEDULEDATE)}: </span>
                  <span style={{ marginLeft: 5 }}>
                    {item.scheduledDate !== null
                      ? moment(item.scheduledDate).format('YYYY-MM-DD')
                      : '-'}{' '}
                    &nbsp;{''}
                  </span>
                </div>
              </div>
              <div>
                <div className='d-flex' style={{ justifyContent: 'end' }}>
                  <label style={{ fontSize: '6px' }}>{item?.txnCcy}</label>
                  &nbsp;
                  <NumberFormat
                    value={item?.amount}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={''}
                    className='float-right'
                    fixedDecimalScale={true}
                    decimalScale={2}
                    allowEmptyFormatting
                  />
                </div>
                <div>
                  <span>{getTransferType(item?.transferType)}</span>
                </div>
              </div>
            </div>
            {expanded === index && (
              <div className='loan-details'>
                <div className='row beneficiary-details justify-space-between '>
                  <div className='col-12'>
                    <div className='row'>
                      <div className='col-4'>
                        <div className='label'>{t(VIEW_SCHEDULED_KEY.RECEIPT_NO)}</div>
                        <div className='value'>{item?.receiptNo || '-'}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(VIEW_SCHEDULED_KEY.SOURCE_ACCOUNT_NUMBER)}</div>
                        <div className='value'>{item?.srcAccount}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(VIEW_SCHEDULED_KEY.SERVICENO)}</div>
                        <div className='value'>{item?.serviceNumber || '-'}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(VIEW_SCHEDULED_KEY.SCHEDULED_AMOUNT)}</div>
                        <div className='value'>
                          {item?.amount !== null ? (
                            <NumberFormat
                              value={item?.amount}
                              displayType={'text'}
                              thousandSeparator={true}
                              prefix={''}
                              fixedDecimalScale={true}
                              decimalScale={2}
                              allowEmptyFormatting
                            />
                          ) : (
                            '-'
                          )}
                        </div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(VIEW_SCHEDULED_KEY.SERVICE_PROVIDER)}</div>
                        <div className='value'>{item?.serviceProvider || '-'}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(VIEW_SCHEDULED_KEY.SCHEDULED_ACTIVE_STATUS)}</div>
                        <div className='value'>
                          {item?.activeStatus === 'A' && 'Pending'}
                          {item?.activeStatus === 'C' && 'Cancelled'}
                          {item?.activeStatus === 'I' && 'Completed'}
                        </div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(VIEW_SCHEDULED_KEY.SCHEDULEDATE)}</div>
                        {item.scheduledDate !== null ? (
                          <div className='value'>
                            {moment(item.scheduledDate).format('YYYY-MM-DD')}
                          </div>
                        ) : (
                          '-'
                        )}
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(VIEW_SCHEDULED_KEY.SCHEDULED_CREATED_DATE)}</div>
                        <div className='value'>
                          {/* {moment(item?.createdDate).format("YYYY-MM-DD") || "-"} */}
                          {moment(item.createdDate).format('YYYY-MM-DD')} &nbsp;{''}
                          {moment(item.createdDate).format('HH:MM:SS')}
                        </div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(VIEW_SCHEDULED_KEY.SCHEDULED_STATUS)}</div>
                        <div className='value'>{item?.scheduledStatus || '-'}</div>
                      </div>
                    </div>

                    <div class='row'>
                      {item.scheduledStatus === 'PENDING' && (
                        <h6
                          className='download-link'
                          disabled={loading}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            verifyCancelScheduledPayment(item)
                          }}>
                          {t(VIEW_SCHEDULED_KEY.SCHEDULED_CANCEL)}
                        </h6>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
        <div className='d-flex justify-content-center mb-5 mt-2'>
          {!loading && scheduledList?.length > 0 && (
            <Pagination
              activePage={currentPage}
              itemsCountPerPage={pageLimit}
              totalItemsCount={totalRecords}
              pageRangeDisplayed={5}
              itemClass='page-item'
              linkClass='page-link'
              onChange={paginationChange}
            />
          )}
        </div>
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='SCHEDULED_PAYMENTS'
      showEmptySpace={true}
      keyPath={'SCHEDULED_PAYMENTS'}>
      {renderSwitch()}
    </LayoutWithOutAccountCard>
  )
}
